module.exports = __webpack_public_path__ + "static/img/course07.c21eeeb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/course07.jpg
// module id = Zk6m
// module chunks = 101